import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { OrderService } from 'src/app/services/order.service';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Renderer2,
  HostListener,
  TemplateRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import SignaturePad from 'signature_pad';
import { SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ImageGeneratorService } from '../services/image-generator.service';
import { ESignService } from '../services/e-sign.service';
import { MessageService } from 'primeng/api';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
import { PDFDocument } from 'pdf-lib';
import { ClientDetailsService } from '../services/client-details.service';
import * as bootstrap from 'bootstrap';
import { environment } from 'src/environments/environment';
import { DomainType } from '../enum/domain-type.enum';
import { UrlValidatorService } from '../services/url-validator.service';
import { PdfVirtualViewerComponent } from '../shared-components/pdf-virtual-viewer/pdf-virtual-viewer.component';
import { getSignatureBoxSizePx } from '../shared-components/signature-box.util';

interface Coordinates {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}

interface PositionDetails {
  [key: string]: Coordinates[];
}
@Component({
  selector: 'app-sign-link',
  templateUrl: './sign-link.component.html',
  styleUrls: ['./sign-link.component.scss'],
  standalone: false,
})
export class SignLinkComponent implements OnInit {
  showSign: boolean = true;
  showFinish: boolean = true;
  @ViewChild('otpScreen') otpScreen: TemplateRef<any>;
  @ViewChild('userImage') userImage: TemplateRef<any>;
  @ViewChild('geoFencingModal') geoFencingModal: TemplateRef<any>;
  @ViewChild('scrollPane') scrollPaneRef?: ElementRef<HTMLDivElement>;
  @ViewChild('pdfViewer') pdfViewer?: PdfVirtualViewerComponent;
  geoFencingData: any;
  isGeoFencingAllowed: boolean = true;
  interval: any;
  selectedUserEmail: any;
  showOtpMethod: boolean = true;
  enableCaptureImage: boolean = true;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.showSign = window.innerWidth > 740;
  }
  signPad: any;
  @ViewChild('signPadCanvas', { static: false })
  signaturePadElement: ElementRef;
  @ViewChild('signatureWarning') signatureWarningTemplate: any;
  isChecked: boolean = false;
  selectedConsentLang: string = 'en';
  consentLanguages = [
    { code: 'en', label: 'English' },
    { code: 'hi', label: 'हिन्दी' },
    { code: 'bn', label: 'বাংলা' },
    { code: 'te', label: 'తెలుగు' },
    { code: 'mr', label: 'मराठी' },
    { code: 'ta', label: 'தமிழ்' },
    { code: 'gu', label: 'ગુજરાતી' },
    { code: 'kn', label: 'ಕನ್ನಡ' },
    { code: 'or', label: 'ଓଡ଼ିଆ' },
    { code: 'ml', label: 'മലയാളം' },
    { code: 'pa', label: 'ਪੰਜਾਬੀ' },
    { code: 'as', label: 'অসমীয়া' },
  ];
  signImage: any;
  /** signImage padded to the signature box's shape; this is what gets submitted. */
  stampImage: string = '';
  orderId: string;
  intials: string;
  pdfUrl: Uint8Array | null = null;
  signatoryDetails: any = {};
  queryParams: any;
  signerData: any = [];
  pageCheck: any;
  selectedFile: string;
  fileName: string = 'Upload Image';
  pdfSource: any;
  savedSignature: string | null = null;
  savedSignatureName: string | null = null;
  originalSignatoryName: string | null = null;
  signOption: string = 'select';
  imageStyle: string | ArrayBuffer;
  isSignatureValid: boolean = false;
  isSignFailed: boolean = false;

  isEmailButtonDisabled: boolean = false;
  emailCooldownTime: number = 0;
  private emailCooldownInterval: any;

  redirecturl: string = '';

  displayConsentModal = false;

  signStyle = [
    { name: 'Comic Sans', code: "italic 70px 'Comic Sans MS', cursive" },
    { name: 'Brush Script', code: "italic 70px 'Brush Script MT', cursive" },
    {
      name: 'Lucida Calligraphy',
      code: "italic 70px 'Lucida Calligraphy', cursive",
    },
    { name: 'Apple Chancery', code: "italic 70px 'Apple Chancery', cursive" },
    { name: 'Arial', code: 'italic 70px Arial, sans-serif' },
    { name: 'Times New Roman', code: "italic 70px 'Times New Roman', serif" },
    { name: 'Cambria', code: 'italic 70px Cambria, serif' },
    { name: 'Fantasy', code: 'italic 70px Fantasy, sans-serif' },
    { name: 'Monospace', code: "italic 70px 'Courier New', monospace" },
    { name: 'Verdana', code: 'italic 70px Verdana, sans-serif' },
    { name: 'Georgia', code: 'italic 70px Georgia, serif' },
    { name: 'Helvetica', code: 'italic 70px Helvetica, sans-serif' },
    { name: 'Impact', code: 'italic 70px Impact, sans-serif' },
    { name: 'Lucida Console', code: "italic 70px 'Lucida Console', monospace" },
    { name: 'Palatino', code: "italic 70px 'Palatino Linotype', serif" },
    { name: 'Courier', code: "italic 70px 'Courier New', monospace" },
    { name: 'Garamond', code: "italic 70px 'Adobe Garamond Pro', serif" },
    { name: 'Bookman', code: "italic 70px 'Bookman Old Style', serif" },
  ];
  selectedStyle: string = "italic 70px 'Brush Script MT', cursive";
  selectedName: string;
  positionDetails: any = {};
  defaultPositionDetails: any = [];
  get totalSignaturePositions(): number {
    const positionsByPage: any = this.positionDetails || {};
    return Object.keys(positionsByPage).reduce(
      (total: number, page: string) => total + (positionsByPage[page]?.length || 0),
      0
    );
  }

  get overlayPages(): Set<number> {
    return new Set(Object.keys(this.positionDetails || {}).map(Number));
  }

  pageVariable = 1;
  numPdfPages: any = 1;
  pageNo: number = 1;

  otherSignerDetails: any = [];
  beforeSigners: any = [];
  afterSigners: any = [];
  esignId: string;
  signatoryId: string;
  zeroSigners: any = [];
  pageHeight: number;
  pageWidth: number;
  ipAddress: any;
  isDocumentSigned: boolean = false;
  isEstampPending: boolean = false;
  public webcamImage: WebcamImage = null;
  showWebcam: boolean;
  signPosition: string = '';
  signPages: number[];
  base64Data: string;
  orderType: any;
  userData: any;
  completedSigners: any = [];

  timeLeft: number = 60;
  validOTP: boolean = false;
  otp: string;
  sendOtp: boolean = false;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
  };
  enableOtp: boolean = true;
  showOtpComponent: boolean = true;
  sendOtpLink: boolean = false;
  signatoryName: string;
  private isClosingModal: boolean = false;
  private consentShown: boolean = false;

  // ── Session auto-refresh timer (5 minutes) ──
  sessionTimeLeft: number = 5 * 60;
  private sessionTimerInterval: any;
  constructor(
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private imageGeneratorService: ImageGeneratorService,
    private activeRouter: ActivatedRoute,
    private eSignService: ESignService,
    private renderer: Renderer2,
    private messageService: MessageService,
    private clientDetailsService: ClientDetailsService,
    private router: Router,
    private urlValidator: UrlValidatorService,
    private orderService: OrderService,
    private analyticsService: AnalyticsService,
    private cdr: ChangeDetectorRef,
    public translate: TranslateService,
  ) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    this.activeRouter.queryParams.subscribe((queryParams) => {
      this.queryParams = queryParams;
      this.esignId = this.queryParams.esign_id;
      this.signatoryId = this.queryParams.signatory_id;
    });

    this.showSign = window.innerWidth > 740;
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.spinner.hide();
    this.renderer.setStyle(document.body, 'overflow-y', 'hidden');
    this.getSignerDetails();
    this.getClientData();
    this.startTimer();
    this.startSessionTimer();
  }

  // Starts a 5-minute countdown. When it reaches 0 the page auto-refreshes.
  startSessionTimer() {
    clearInterval(this.sessionTimerInterval);
    this.sessionTimeLeft = 5 * 60;
    this.sessionTimerInterval = setInterval(() => {
      if (this.sessionTimeLeft > 0) {
        this.sessionTimeLeft--;
        this.cdr.detectChanges();
      } else {
        clearInterval(this.sessionTimerInterval);
        window.location.reload();
      }
    }, 1000);
  }

  // Formats seconds as MM:SS for display.
  get sessionTimerDisplay(): string {
    const minutes = Math.floor(this.sessionTimeLeft / 60);
    const seconds = this.sessionTimeLeft % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }

  getSignerDetails() {
    this.eSignService.getSignerDetails(this.queryParams).subscribe((res) => {
      if (res['message'] === 'Signatory not found') {
        this.signerData = { signatory_details: { status: 'EXPIRED' } };
        this.signatoryDetails = this.signerData.signatory_details;
        this.isDocumentSigned = true;
        this.spinner.hide();
        this.cdr.detectChanges();
        return;
      }

      if (
        res['message'] === 'No data found' ||
        !res['content'] ||
        Object.keys(res['content']).length === 0
      ) {
        this.isEstampPending = true;
        this.spinner.hide();
        this.cdr.detectChanges();
        return;
      }

      this.signerData = res['content'];
      this.isEstampPending = res['content'].estamp_done === false;
      if (this.isEstampPending) {
        this.spinner.hide();
        this.cdr.detectChanges();
        return;
      }
      this.pdfUrl = this.base64ToUint8Array(res['content'].document);
      this.orderType = this.signerData.order_type;
      this.signatoryDetails = this.signerData.signatory_details;
      this.savedSignature = this.signatoryDetails.signature || null;
      this.savedSignatureName = this.signatoryDetails.signatureName || null;
      this.signatoryName = this.signatoryDetails.name;
      this.originalSignatoryName = this.signatoryDetails.name;
      this.orderId = this.signerData.order_id;
      this.selectedName = this.signatoryDetails.name;
      this.selectedUserEmail = this.signatoryDetails.email;

      // FIX 2: Guard against null position_details from API
      // BEFORE: this.positionDetails = this.signatoryDetails.position_details;
      // If API returns position_details: null → positionDetails = null
      // Template evaluates null[pageVariable] = null['1'] → CRASH
      this.positionDetails = this.signatoryDetails.position_details || {};

      this.signPosition = this.signatoryDetails.sign_position;
      this.enableCaptureImage = this.signatoryDetails.esign_webcam;
      if (this.signatoryDetails.status === 'FAILED') {
        this.isSignFailed = true;
        this.router.navigate(['signFailed']);
        return;
      }
      if (
        this.signatoryDetails.status === 'COMPLETED' ||
        this.signatoryDetails.status === 'CANCELLED' ||
        this.signatoryDetails.status === 'EXPIRED'
      ) {
        this.isDocumentSigned = true;
      }
      this.otherSignerDetails = this.signerData.other_signatories;
      this.getSequenceOrder();
      if (this.signatoryDetails.name) {
        this.selectTextSign('Name', 'Brush Script MT');
      }
      if (this.orderType === 'CAT_EDIT') {
        this.getReSizeDocument(res['content'].document);
      }
      if (!this.isDocumentSigned && !this.consentShown) {
        if (this.showOtpMethod && this.signatoryDetails.esign_otp) {
          this.onOtpMethod();
          this.showOtpMethod = false;
        } else {
          this.displayConsentModal = true;
          this.consentShown = true;
        }
      }
      if (this.orderId) {
        this.getIpGeofencing();
      } else {
        console.error('Order ID is undefined, cannot check geo-fencing');
      }
      this.cdr.detectChanges();
    });
    this.spinner.hide();
  }

  showGeoFencingModal() {
    this.modalService
      .open(this.geoFencingModal, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'geo-fencing-modal',
      })
      .result.then((result) => {
        if (result === 'close') {
          const apiUrl = environment.apiURL;
          const url = new URL(apiUrl);
          url.hostname = url.hostname.replace('-api', '');
          const finalUrl = url.toString();
          if (
            this.urlValidator.isValidRedirectUrl(finalUrl, DomainType.DOQFY)
          ) {
            window.location.href = finalUrl;
          }
        }
      });
  }

  getIpGeofencing() {
    const queryParams = { order_id: this.orderId };
    this.eSignService.getIpGeofencing(queryParams).subscribe(
      (res) => {
        this.geoFencingData = res.content;
        if (res.content.allowed_ip === false) {
          this.showGeoFencingModal();
        }
      },
      (error) => {
        console.error('Error fetching geo-fencing data:', error);
        this.isGeoFencingAllowed = true;
      },
    );
  }

  async getReSizeDocument(base64String) {
    try {
      const pdfDoc = await PDFDocument.load(base64String);
      this.numPdfPages = pdfDoc.getPageCount();
      for (let i = 0; i < pdfDoc.getPageCount(); i++) {
        const page = pdfDoc.getPage(i);
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = 595;
        canvas.height = 842;
        $('.example-boundary').css('width', this.convertPtToPx(595) + 'px');
        $('.example-boundary').css('height', this.convertPtToPx(842) + 'px');
        const { width, height } = page.getSize();
        await page.drawText('', { x: 0, y: height });
        const pageImage = canvas.toDataURL('image/png');
        const imageBytes = Uint8Array.from(atob(pageImage.split(',')[1]), (c) =>
          c.charCodeAt(0),
        );
        const image = await pdfDoc.embedPng(imageBytes);
        page.drawImage(image, {
          x: 0,
          y: height,
          width,
          height,
        });
      }
      const modifiedPdfBytes = await pdfDoc.save();
      this.base64Data = this.arrayBufferToBase64(
        modifiedPdfBytes.buffer as ArrayBuffer,
      );
    } catch (error) {
      console.error('Error loading PDF:', error);
    }
  }

  arrayBufferToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    const chunkSize = 0x8000;
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
    }
    return window.btoa(binary);
  }

  gotoPagenumber(positionDetails: any) {
    this.signPages = Object.keys(positionDetails).map(Number).sort((a, b) => a - b);
    this.pageNo = this.signPages[0];
    if (this.signPages[0]) {
      this.pageChange(this.signPages[0]);
    }
  }

  getSequenceOrder() {
    this.beforeSigners = [];
    this.afterSigners = [];
    if (this.otherSignerDetails.length > 0) {
      this.otherSignerDetails.forEach((element) => {
        if (
          element.signatory_sequence >
            this.signatoryDetails.signatory_sequence ||
          element.status != 'COMPLETED'
        ) {
          this.afterSigners.push(element);
        } else if (element.signatory_sequence === 0) {
          this.zeroSigners.push(element);
        } else if (
          element.signatory_sequence === 0 &&
          element.status === 'COMPLETED'
        ) {
          this.beforeSigners.push(element);
        }
        if (element.status === 'COMPLETED') {
          this.completedSigners.push(element);
        }
      });
    }
  }

  ngAfterViewInit() {
    this.signPad = new SignaturePad(this.signaturePadElement.nativeElement);
  }

  saveSignPad(userImage) {
    const base64ImageData = this.signPad.toDataURL();
    if (base64ImageData) {
      setTimeout(() => {
        this.getCodedImage(base64ImageData);
      }, 1);
      this.enableCaptureImage ? this.loadCam(userImage) : '';
    } else {
      this.modalService.open(this.signatureWarningTemplate, {
        backdrop: 'static',
        keyboard: false,
      });
    }
  }

  onSignatureWarningOk(modalRef: NgbModalRef) {
    modalRef.close();
    window.location.reload();
  }

  async getCodedImage(baseImage: string) {
    // Never submit a stamp left over from an earlier attempt.
    this.stampImage = '';
    const isBlank =
      await this.imageGeneratorService.checkIfImageIsBlank(baseImage);

    if (isBlank) {
      this.signImage = '';
      this.isSignatureValid = false;
      this.modalService.open(this.signatureWarningTemplate, {
        backdrop: 'static',
        keyboard: false,
      });
      return;
    }

    const currentDate = new Date();
    const topText = 'Authenticated through Doqfy.in';
    const bottomText =
      'ID:' +
      this.signatoryId +
      ',' +
      currentDate.toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });

    try {
      // Always build the complete electronic sign first, exactly as it's
      // always looked — unconditionally, regardless of is_authorised.
      const completeElectronicSign = await this.imageGeneratorService.addBordersAndText(
        baseImage,
        topText,
        bottomText,
      );

      const isAuthorised = !!this.signatoryDetails?.is_authorised && !!this.signatoryDetails?.authorised_for;
      const modifiedImage = isAuthorised
        ? await this.imageGeneratorService.generateAuthorisedFrameWithSignature(
            completeElectronicSign,
            this.signatoryDetails.authorised_for,
          )
        : completeElectronicSign;
      // What's placed on the PDF: the same stamp padded to the signature box's
      // shape so it rests on the box bottom, level with Aadhaar, at the same
      // size. signImage stays as the on-screen preview.
      const stampImage = await this.imageGeneratorService.padToSignatureBox(modifiedImage);
      setTimeout(() => {
        this.signImage = modifiedImage;
        this.stampImage = stampImage;
        this.isSignatureValid = true;
        this.cdr.detectChanges();
      }, 0);
    } catch (error) {
      console.error('Error adding borders and text:', error);
      this.isSignatureValid = false;
    }
  }

  undoSign() {
    const data = this.signPad.toData();
    if (data) {
      data.pop();
      this.signPad.fromData(data);
    }
  }

  clearSignPad() {
    this.signPad.clear();
  }

  clearFile() {
    this.selectedFile = '';
    this.fileName = 'Upload Img';
    const inputElement = <HTMLInputElement>(
      document.getElementById('upload_file')
    );
    inputElement.value = null;
    this.pdfSource = null;
  }

  clearStyle() {}

  saveUploadImage(userImage) {
    this.signImage = this.pdfSource;
    this.getCodedImage(this.signImage);
    this.enableCaptureImage ? this.loadCam(userImage) : '';
  }

  saveSavedSignature(userImage) {
    this.signImage = 'data:image/png;base64,' + this.savedSignature;
    this.getCodedImage(this.signImage);
    this.enableCaptureImage ? this.loadCam(userImage) : '';
  }

  onFileChange(event: any) {
    let files = event.target.files;
    this.selectedFile = files[0];
    let fullFileName = files[0].name;
    this.fileName =
      fullFileName.length > 30
        ? fullFileName.substring(0, 30) + '...'
        : fullFileName;

    let selectedFile = files[0];
    let fileExtension = selectedFile.name.split('.').pop().toLowerCase();
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'bmp'];

    if (allowedExtensions.indexOf(fileExtension) === -1) {
      this.messageService.add({
        severity: 'warning',
        summary: 'Image Type',
        detail: 'Invalid file type. Please select a JPEG, PNG, or BMP image.',
      });
      event.target.value = '';
      return;
    }

    const fileSize = files[0].size / 1024 / 1024;
    if (fileSize > 10) {
      this.messageService.add({
        severity: 'warning',
        summary: 'Image Type',
        detail: 'File should be less than 10MB in size',
      });
      const inputElement = <HTMLInputElement>(
        document.getElementById('upload_file')
      );
      inputElement.value = '';
      return;
    }

    let splitName = files[0].name.split('.');
    if (splitName.length > 2) {
      this.messageService.add({
        severity: 'warning',
        summary: 'Image Type',
        detail: 'File name should have only single extension',
      });
      const inputElement = <HTMLInputElement>(
        document.getElementById('upload_file')
      );
      inputElement.value = '';
      return;
    }

    let $img: any = document.querySelector('#upload_file');

    if (typeof FileReader !== 'undefined') {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSource = e.target.result;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(files[0]);
    }
  }

  saveStylingImage(userImage) {
    this.signImage = this.imageStyle;
    this.getCodedImage(this.signImage);
    this.enableCaptureImage ? this.loadCam(userImage) : '';
  }

  selectTextSign(value: string, style: string) {
    this.selectedStyle = 'italic 70px ' + style + ', cursive';
    if (value === 'Name') {
      this.selectedName = this.signatoryDetails.name || this.signatoryName;
      if (this.selectedName && this.selectedName.trim() !== '') {
        this.imageStyle = this.generateWrappedTextImage(
          this.selectedName,
          this.selectedStyle,
        );
      } else {
        this.imageStyle = null;
      }
    }
  }

  textToImage(textToConvert: any, style: string) {
    if (!textToConvert || textToConvert.trim() === '') {
      this.imageStyle = null;
      return;
    }
    try {
      const processedStyle = this.calculateOptimalTextStyle(
        textToConvert,
        style,
      );
      this.imageStyle = this.imageGeneratorService.generateImage(
        textToConvert,
        processedStyle,
      );
    } catch (error) {
      console.error('Error generating image:', error);
      this.imageStyle = null;
    }
  }

  calculateOptimalTextStyle(text: string, originalStyle: string): string {
    const textLength = text.length;
    const fontFamilyMatch = originalStyle
      ? originalStyle.match(/(?:italic\s+)?(?:\d+px\s+)?(.+)/)
      : null;
    const fontFamily = fontFamilyMatch?.[1] ?? 'cursive';

    let fontSize: number;
    switch (true) {
      case textLength <= 10:
        fontSize = 60;
        break;
      case textLength <= 15:
        fontSize = 50;
        break;
      case textLength <= 20:
        fontSize = 45;
        break;
      case textLength <= 25:
        fontSize = 35;
        break;
      case textLength <= 30:
        fontSize = 25;
        break;
      default:
        fontSize = 25;
    }
    return `italic ${fontSize}px ${fontFamily}`;
  }

  generateWrappedTextImage(text: string, style: string): string {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';

    canvas.width = 380;
    canvas.height = 80;
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const fontFamilyMatch = style
      ? style.match(/(?:italic\s+)?(?:\d+px\s+)?(.+)/)
      : null;
    const fontFamily = fontFamilyMatch?.[1] ?? 'cursive';

    ctx.fillStyle = 'black';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';

    const padding = 10;
    const maxWidth = canvas.width - padding * 2;
    const maxHeight = canvas.height - padding * 2;

    let fontSize: number;
    switch (true) {
      case text.length < 15:
        fontSize = 65;
        break;
      case text.length < 20:
        fontSize = 55;
        break;
      case text.length < 25:
        fontSize = 48;
        break;
      case text.length < 30:
        fontSize = 42;
        break;
      default:
        fontSize = 35;
    }

    ctx.font = `italic ${fontSize}px ${fontFamily}`;

    const wrapText = (text: string, maxWidth: number): string[] => {
      const words = text.split(' ');
      const lines: string[] = [];
      let currentLine = words[0];
      for (let i = 1; i < words.length; i++) {
        const testLine = currentLine + ' ' + words[i];
        const testWidth = ctx.measureText(testLine).width;
        if (testWidth > maxWidth || testLine.length > 25) {
          lines.push(currentLine);
          currentLine = words[i];
        } else {
          currentLine = testLine;
        }
      }
      lines.push(currentLine);
      return lines;
    };

    let lines = wrapText(text, maxWidth);
    let lineHeight = fontSize * 1.2;
    let totalHeight = lines.length * lineHeight;

    while (totalHeight > maxHeight && fontSize > 12) {
      fontSize -= 2;
      ctx.font = `italic ${fontSize}px ${fontFamily}`;
      lineHeight = fontSize * 1.2;
      lines = wrapText(text, maxWidth);
      totalHeight = lines.length * lineHeight;
    }

    const startY = padding + (maxHeight - totalHeight) / 2;
    lines.forEach((line, index) => {
      const y = startY + index * lineHeight;
      ctx.fillText(line, padding, y);
    });

    return canvas.toDataURL();
  }

  getStyleType() {
    this.signatoryDetails.name = this.signatoryName;
    this.selectedName = this.signatoryName;
    if (this.signOption === 'select' && this.selectedStyle) {
      this.imageStyle = this.generateWrappedTextImage(
        this.signatoryName,
        this.selectedStyle,
      );
    }
  }

  onNameChange() {
    this.signatoryDetails.name = this.signatoryName;
    this.selectedName = this.signatoryName;
    if (this.signOption === 'select' && this.selectedStyle) {
      this.imageStyle = this.generateWrappedTextImage(
        this.signatoryName,
        this.selectedStyle,
      );
    }
  }
  
  selectSavedSignatureTab() {
    this.signOption = 'saved';
    this.signatoryName = this.savedSignatureName;
    this.signatoryDetails.name = this.savedSignatureName;
    this.selectedName = this.savedSignatureName;
  }
  
  selectSignatureTab(option: string) {
    this.signOption = option;
    this.signatoryName = this.originalSignatoryName;
    this.signatoryDetails.name = this.originalSignatoryName;
    this.selectedName = this.originalSignatoryName;
    if (
      this.signatoryName &&
      this.signatoryName.trim() !== '' &&
      this.selectedStyle
    ) {
      this.imageStyle = this.generateWrappedTextImage(
        this.signatoryName,
        this.selectedStyle,
      );
    } else {
      this.imageStyle = null;
    }
  }

  clearImage() {
    if (this.signOption === 'select') {
      this.clearStyle();
    } else if (this.signOption === 'draw') {
      this.clearSignPad();
    } else if (this.signOption === 'upload') {
      this.clearFile();
    }
  }

  saveImage(userImage) {
    if (
      !this.signatoryDetails.name ||
      this.signatoryDetails.name.trim() === ''
    ) {
      this.modalService.open(this.signatureWarningTemplate, {
        backdrop: 'static',
        keyboard: false,
      });
      return;
    }
    if (this.signOption === 'select') {
      this.saveStylingImage(userImage);
    } else if (this.signOption === 'draw') {
      this.saveSignPad(userImage);
    } else if (this.signOption === 'upload') {
      if (this.pdfSource) {
        this.saveUploadImage(userImage);
      } else {
        this.modalService.open(this.signatureWarningTemplate, {
          backdrop: 'static',
          keyboard: false,
        });
      }
    } else if (this.signOption === 'saved') {
      if (this.savedSignature) {
        this.saveSavedSignature(userImage);
      } else {
        this.modalService.open(this.signatureWarningTemplate, {
          backdrop: 'static',
          keyboard: false,
        });
      }
    }
    this.sendUserDetails();
  }

  closeModel() {
    this.clearFile();
    this.modalService.dismissAll();
  }

  // async SubmitSign() {
  //   this.spinner.show();
  //   if (this.enableCaptureImage && !this.webcamImage) {
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Image Required',
  //       detail: 'Image is not captured properly. Please capture image again.'
  //     });
  //     this.spinner.hide();
  //     return;
  //   }

  //   if (
  //     this.positionDetails &&
  //     this.esignId &&
  //     this.signatoryId &&
  //     this.signImage &&
  //     this.userData
  //   ) {
  //     const data = {
  //       browser_data: this.userData,
  //       position_data: this.positionDetails,
  //       esign_id: this.esignId,
  //       signatory_id: this.signatoryId,
  //       signature: this.signImage.split(',')[1],
  //       ipAddress: this.ipAddress,
  //       document: ''
  //     };

  //     if (this.orderType === 'CAT_EDIT') {
  //       data.document = this.base64Data.split(',')[1];
  //     }

  //     this.eSignService.sendSignatureDetails(data).subscribe(
  //       (res) => {
  //         if (res) {
  //           setTimeout(() => {
  //             this.getSignerDetailsAndRedirect();
  //           }, 1000);
  //         }
  //       },
  //       (error) => {
  //         this.spinner.hide();
  //         console.error('Signature submission failed:', error);
  //         this.messageService.add({
  //           severity: 'error',
  //           detail: 'Signature submission failed. Please try again.'
  //         });
  //       }
  //     );
  //   } else {
  //     this.spinner.hide();
  //     this.modalService.open(this.signatureWarningTemplate, {
  //       backdrop: 'static',
  //       keyboard: false
  //     });
  //   }
  // }

  SubmitSign() {
    this.spinner.show();

    // STRICT HARD STOP: Camera ya photo na hone par yahin block karo
    if (this.enableCaptureImage && !this.webcamImage) {
      this.messageService.add({
        severity: 'error',
        summary: 'Camera/Image Required',
        detail:
          'Webcam image is mandatory for the audit trail. Please connect a camera or allow permissions.',
      });
      this.spinner.hide();
      return;
    }

    if (
      this.positionDetails &&
      this.esignId &&
      this.signatoryId &&
      this.signImage &&
      this.userData
    ) {
      const data: any = {
        browser_data: this.userData,
        position_data: this.positionDetails || {},
        esign_id: this.esignId,
        signatory_id: this.signatoryId,
        signature: (this.stampImage || this.signImage).split(',')[1],
        ipAddress: this.ipAddress,
        document: '',
      };

      if (this.orderType === 'CAT_EDIT') {
        data.document = this.base64Data.split(',')[1];
      }

      this.eSignService
        .sendUserDetails({
          browser_data: this.userData,
          esign_id: this.esignId,
          signatory_id: this.signatoryId,
          user_image: this.webcamImage,
        })
        .subscribe({
          next: () => {
            this.eSignService.sendSignatureDetails(data).subscribe({
              next: (res) => {
                if (res) {
                  setTimeout(() => {
                    this.getSignerDetailsAndRedirect();
                  }, 1000);
                }
              },
              error: (error) => {
                this.spinner.hide();
                console.error('Signature submission failed:', error);
                this.messageService.add({
                  severity: 'error',
                  detail: 'Signature submission failed. Please try again.',
                });
              },
            });
          },
          error: (err) => {
            this.spinner.hide();
            this.messageService.add({
              severity: 'error',
              summary: 'Verification Failed',
              detail:
                err?.error?.message ||
                'Verification failed. Could not capture image/audit data.',
            });
          },
        });
    } else {
      this.spinner.hide();
      this.modalService.open(this.signatureWarningTemplate, {
        backdrop: 'static',
        keyboard: false,
      });
    }
  }

  getSignerDetailsAndRedirect() {
    this.getSignerDetails();
    if (this.redirecturl) {
      this.spinner.hide();
      this.messageService.add({
        severity: 'success',
        detail: 'Process completed. Redirecting to sign...',
      });
      setTimeout(() => {
        if (
          this.urlValidator.isValidRedirectUrl(
            this.redirecturl.toString(),
            DomainType.DOQFY,
          )
        )
          window.location.href = this.redirecturl;
      }, 1500);
    } else {
      this.spinner.hide();
      this.messageService.add({
        severity: 'success',
        detail: 'Process completed successfully.',
      });
    }
  }

  ngOnDestroy() {
    this.redirecturl = '';
    if (this.emailCooldownInterval) {
      clearInterval(this.emailCooldownInterval);
    }
    if (this.sessionTimerInterval) {
      clearInterval(this.sessionTimerInterval);
    }
  }

  reTakeImage(content) {
    this.webcamImage = null;
    this.loadCam(content);
  }

  loadCam(content) {
    if (!this.webcamImage) {
      this.openCam();
      this.modalService
        .open(content, {
          size: 'lg',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static',
          keyboard: false,
        })
        .result.then(
          (result) => {
            console.log(result);
          },
          (reason) => {
            console.log(reason);
          },
        );
    }
  }

  closeTab() {
    this.closeModel();
    window.close();
  }

  clearSign() {}

  base64ToUint8Array(base64: string): Uint8Array<ArrayBuffer> {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
  }

  onDocLoaded(event: { numPages: number }) {
    this.numPdfPages = event.numPages;
    this.selectTextSign('Name', 'Brush Script MT');

      if (this.positionDetails['ALL']) {
        const coordinates: Coordinates[] = this.positionDetails['ALL'];
        const newPositionDetails: PositionDetails = {};
        for (let i = 1; i <= this.numPdfPages; i++) {
          newPositionDetails[i.toString()] = coordinates;
        }
        delete this.positionDetails['ALL'];
        Object.assign(this.positionDetails, newPositionDetails);
      }

      this.cdr.detectChanges();
      this.gotoPagenumber(this.positionDetails);
  }

 
  onPageRendered(event: { pageNum: number; widthPx: number; heightPx: number }) {
    if (event.pageNum === 1) {
      this.pageHeight = event.heightPx;
      this.pageWidth = event.widthPx;
    }
  }

  convertPtToPx(pt: number) {
    return (4 / 3) * pt;
  }

  // Scrolls the given page's own boundary into view — with one pdf-viewer
  // per page there's no single "current page" to reassign anymore.
  pageChange(pageNo: number) {
    this.pageVariable = pageNo;
    this.pdfViewer?.scrollToPage(pageNo);
  }

  private getBoxXY(item, pageNum: number): { x: number; y: number } {
    // drag-drop.component (the tool that creates DRAG_DROP positions) stores
    // plain top-down pixel coordinates and displays them with no Y-flip at
    // all — matching that here (instead of flipping) is what makes positions
    // line up with where they were actually placed.
    const x = Math.floor(this.convertPtToPx(item.x1));
    const rawY = Math.floor(this.convertPtToPx(item.y1));
    if (this.signPosition === 'DRAG_DROP') {
      return { x, y: rawY };
    }
    if (this.pageHeight < 1100 && rawY > 1000) {
      return { x, y: this.pageHeight - 130 + 10 };
    }
    return { x, y: rawY + 10 };
  }

  getPosition(item, pageNum: number) {
    if (!item) return 'translate3d(0px, 0px, 0px)';
    const { x, y } = this.getBoxXY(item, pageNum);
    return `translate3d(${x}px, ${y}px, 0px)`;
  }

  // The signature area is drawn at the size this order will actually be signed
  // at (its own x1..x2 / y1..y2), instead of a fixed 120x70 that matched none
  // of the placements. New orders all use the common signature box.
  getBoxSizePx(item): { width: number; height: number } {
    return getSignatureBoxSizePx(item);
  }

  // Authorised signatory, BEFORE signing: "For"/"Authorised Signatory" are
  // separate elements positioned above/below the signature box — the box
  // itself (size, position, click behaviour) is completely unchanged; these
  // are just extra labels placed around it using the same anchor point.
  // Clamped to the page's actual bounds so a box near the top/bottom edge
  // doesn't let a label float off the page entirely.
  getAuthorisedLabelPosition(item, pageNum: number, edge: 'top' | 'bottom') {
    if (!item) return 'translate3d(0px, 0px, 0px)';
    const { x, y } = this.getBoxXY(item, pageNum);
    const labelHeight = 14; // approx rendered height of one line of label text
    // Bottom label sits just under the box: its height plus a small gap.
    let offsetY = edge === 'top' ? y - 16 : y + this.getBoxSizePx(item).height + 4;
    if (edge === 'top') {
      offsetY = Math.max(0, offsetY);
    } else if (this.pageHeight) {
      offsetY = Math.min(offsetY, Math.max(0, this.pageHeight - labelHeight));
    }
    return `translate3d(${x}px, ${offsetY}px, 0px)`;
  }

  // Authorised signatory, AFTER signing: the box grows from its normal
  // signature-area size to a properly sized frame, so the composited
  // "For {name}" / real signature / "Authorised Signatory" image (built in
  // getCodedImage()) is legible instead of squeezed into the tiny box.
  // Grown from the same base anchor as the normal box, checking whether
  // that size actually fits the page first (rather than clamping after the
  // fact), so it never silently jumps away from where the signature is.
  getSignedAuthorisedBoxPosition(item, pageNum: number): string {
    if (!item) return 'translate3d(0px, 0px, 0px)';
    const { x: baseX, y: baseY } = this.getBoxXY(item, pageNum);
    const width = 200;
    const height = 160;

    const pageWidthPx = this.pageWidth || baseX + width;
    const pageHeightPx = this.pageHeight || baseY + height;

    const x = baseX + width <= pageWidthPx ? baseX : Math.max(0, pageWidthPx - width);
    const y = baseY + height <= pageHeightPx ? baseY : Math.max(0, pageHeightPx - height);

    return `translate3d(${x}px, ${y}px, 0px)`;
  }

  convertPxToPt(px: number) {
    return (4 / 3) * px;
  }

  getClientData() {
    this.clientDetailsService.getClientDetails().then((res) => {
      this.userData = {
        ip_address: res.ip_address,
        latitude: res.latitude,
        longitude: res.longitude,
        browser: res.device_info.browser,
        device_type: res.device_info.deviceType,
        timeStamp: res.timeStamp,
        location: '--',
        city: '--',
        state: '--',
        country: '--',
      };
      setTimeout(() => {
        this.getLocationDetails(res);
      }, 1000);
    });
  }

// sendUserDetails(): void {

//   if (!this.userData) {
//     return;
//   }

//   if (this.enableCaptureImage && !this.webcamImage) {
//     this.messageService.add({
//       severity: 'warn',
//       summary: 'Image Required',
//       detail: 'Image is not captured properly. Please capture image again.',
//     });
//     return;
//   }

//   const payload = {
//     browser_data: this.userData,
//     esign_id: this.esignId,
//     signatory_id: this.signatoryId,

//   };
//   this.eSignService.sendUserDetails(payload).subscribe({
//     next: (res) => {
//       console.log('[Audit Trail] Browser data updated successfully.');
//     },
//     error: (err) => {
//       console.error('[Audit Trail] Error updating browser data:', err);
//       this.messageService.add({
//         severity: 'error',
//         summary: 'Sync Failure',
//         detail: err?.error?.message || 'Failed to update browser profile. Please try again.',
//       });
//     }
//   });
// }

sendUserDetails(): void {
  if (!this.userData) {
    return;
  }

  if (this.enableCaptureImage && !this.webcamImage) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Image Required',
      detail: 'Image is not captured properly. Please capture image again.',
    });
    return;
  }
  const payload = {
    browser_data: this.userData,
    esign_id: this.esignId,
    signatory_id: this.signatoryId,
  };

  this.eSignService.sendUserDetails(payload).subscribe({
    next: (res) => {
      console.log('[Audit Trail] Browser data updated successfully.');
    },
    error: (err) => {
      console.error('[Audit Trail] Error updating browser data:', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Sync Failure',
        detail: err?.error?.message || 'Failed to update browser profile. Please try again.',
      });
    }
  });
}

  getLocationDetails(res) {
    this.clientDetailsService
      .getLocationDetails(res.latitude, res.longitude)
      .subscribe({
        next: (loc: any) => {
          if (!loc) return;
          this.userData = {
            ip_address: res.ip_address,
            latitude: res.latitude,
            longitude: res.longitude,
            browser: res.device_info.browser,
            device_type: res.device_info.deviceType,
            timeStamp: res.timeStamp,
            location: loc?.display_name || '--',
            city: loc?.address?.state_district || loc?.address?.city || '--',
            state: loc?.address?.state || '--',
            country: loc?.address?.country || '--',
          };
        },
        error: (err) => {
          console.warn('Location lookup failed (non-critical):', err);
        },
      });
  }

  // handleImage(webcamImage: any) {
  //   console.log('webcamImage', webcamImage);
  //   if (!webcamImage) {
  //     this.orderService.logOrderTransaction(
  //       this.orderId || 'UNKNOWN_ID',
  //       'IMAGE_CAPTURE_FAILED',
  //       true,
  //       'Camera not ready or image empty',
  //     );
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Camera Not Ready',
  //       detail: 'Please wait for the camera to fully load before capturing.',
  //     });
  //     return;
  //   }
  //   const base64Data = webcamImage.split(',')[1] || '';
  //   const estimatedBytes = (base64Data.length * 3) / 4;

  //   if (estimatedBytes < 10000) {
  //     const sizeKb = (estimatedBytes / 1024).toFixed(2);
  //     this.orderService.logOrderTransaction(
  //       this.orderId || 'UNKNOWN_ID',
  //       'IMAGE_CAPTURE_QUALITY_POOR',
  //       true,
  //       `Image size too small: ${sizeKb} KB`,
  //     );
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Invalid Capture',
  //       detail: 'Camera was not ready. Please wait and try again.',
  //     });
  //     return;
  //   }
  //   this.webcamImage = webcamImage;
  //   const data = {
  //     user_image: this.webcamImage,
  //     order_id: this.orderId,
  //   };
  //   console.log('webcamImagetosend', data);
  //   const isMobileDevice = this.isMobile();
  //   if (this.signatoryDetails && this.signatoryDetails.face_live_detect) {
  //     this.eSignService.detectSignatoryFace(data).subscribe(
  //       (response: any) => {
  //         console.log('Face detection response:', response);

  //         if (response.content.live) {
            
  //           this.orderService.logOrderTransaction(
  //             this.orderId || 'UNKNOWN_ID',
  //             'FACE_DETECTION_SUCCESS',
  //           );
  //           this.messageService.add({
  //             severity: 'success',
  //             summary: 'Success',
  //             detail: 'Capture image successfully.',
  //           });
  //           if (isMobileDevice) {
  //             setTimeout(() => {
  //               this.closeCam();
  //               setTimeout(() => {
  //                 this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
  //               }, 800);
  //             }, 300);
  //           } else {
  //             this.closeCam();
  //             this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
  //           }
  //         } else {
  //           this.orderService.logOrderTransaction(
  //             this.orderId || 'UNKNOWN_ID',
  //             'FACE_DETECTION_FAILED',
  //             true,
  //             'Liveness check failed (Not live)',
  //           );
  //           this.orderService.logOrderTransaction(
  //             this.orderId || 'UNKNOWN_ID',
  //             'FACE_DETECTION_FAILED',
  //             true,
  //             'Liveness check failed (Not live)',
  //           );
  //         }
  //       },
  //       (error) => {
  //         console.error('Face detection error:', error);
  //         this.orderService.logOrderTransaction(
  //           this.orderId || 'UNKNOWN_ID',
  //           'FACE_DETECTION_API_ERROR',
  //           true,
  //           error.message || 'API Error',
  //         );
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error',
  //           detail: 'An error occurred while detecting the face.',
  //         });
  //       },
  //     );
  //   } else {
  //     this.orderService.logOrderTransaction(
  //       this.orderId || 'UNKNOWN_ID',
  //       'IMAGE_CAPTURE_SUCCESS',
  //     );
  //     this.messageService.add({
  //       severity: 'success',
  //       summary: 'Success',
  //       detail: 'Capture image successfully.',
  //     });

  //     if (isMobileDevice) {
  //       setTimeout(() => {
  //         this.closeCam();
  //         setTimeout(() => {
  //           this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
  //         }, 600);
  //       }, 200);
  //     } else {
  //       setTimeout(() => {
  //         this.closeCam();
  //         this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
  //       }, 100);
  //     }
  //   }
  // }

  handleImage(webcamImage: any) {
  if (!webcamImage) {
    return;
  }
  this.webcamImage = webcamImage;
  const data = {
    user_image: this.webcamImage,
    order_id: this.orderId,
  };
  console.log('webcamImagetosend', data);
  const isMobileDevice = this.isMobile();

  if (this.signatoryDetails && this.signatoryDetails.face_live_detect) {
    this.eSignService.detectSignatoryFace(data).subscribe({
      next: (response: any) => {
        console.log('Face detection response:', response);
        if (response.content.live) {
          this.orderService.logOrderTransaction(
            this.orderId || 'UNKNOWN_ID',
            'FACE_DETECTION_SUCCESS',
          );

          this.eSignService.syncCapturedImageInstantly(
            this.webcamImage,
            this.esignId,
            this.signatoryId
          );

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Capture image successfully.',
          });

          if (isMobileDevice) {
            setTimeout(() => {
              this.closeCam();
              setTimeout(() => {
                this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
              }, 400);
            }, 1000);
          } else {
            this.closeCam();
            this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
          }
        }
      }
    });
  } else {
    this.eSignService.syncCapturedImageInstantly(
      this.webcamImage,
      this.esignId,
      this.signatoryId
    );

    this.orderService.logOrderTransaction(
      this.orderId || 'UNKNOWN_ID',
      'IMAGE_CAPTURE_SUCCESS',
    );
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Capture image successfully.',
    });

    if (isMobileDevice) {
      setTimeout(() => {
        this.closeCam();
        setTimeout(() => {
          this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
        }, 400);
      }, 1000);
    } else {
      this.closeCam();
      this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
    }
  }
}

  scrollPage() {
    const body = document.querySelector('body');
    this.renderer.setStyle(body, 'overflow', 'scroll');
  }

  openCam() {
    this.showWebcam = true;
    this.cdr.detectChanges();
  }

  handleInitError(error: WebcamInitError): void {
    this.analyticsService.logSystemError('camera_init', error.message);
    if (
      error.mediaStreamError &&
      error.mediaStreamError.name === 'NotAllowedError'
    ) {
      alert('Please enable camera permissions in your browser settings.');
    }
  }

  closeCam() {
    this.showWebcam = false;
    this.cdr.detectChanges();
    if (this.isMobile()) {
      this.stopAllCameraStreams();
      setTimeout(() => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          console.log('Camera cleanup completed for mobile');
        }
      }, 150);
    }
    this.modalService.dismissAll();
  }

  isMobile(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  }

  private stopAllCameraStreams() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          devices.forEach((device) => {
            if (device.kind === 'videoinput') {
            }
          });
        })
        .catch((err) => console.log('Device enumeration error:', err));
    }
  }

  onCheckboxChange(event: any) {
    this.isChecked = event.target.checked;
    this.displayConsentModal = false;
    if (this.isChecked) {
      this.renderer.setStyle(document.body, 'overflow-y', 'scroll');
      this.enableCaptureImage ? this.loadCam(this.userImage) : '';
    } else {
      this.renderer.setStyle(document.body, 'overflow-y', 'hidden');
    }
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {},
        (error) => {
          console.error('Error getting location:', error.message);
        },
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  }

  onOtpMethod() {
    this.modalService
      .open(this.otpScreen, {
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        },
      );
  }

  onOtpChange(otp: string) {
    this.otp = otp;
    if (this.otp.length == 6) {
      this.enableOtp = false;
    } else {
      this.enableOtp = true;
    }
  }

  startTimer() {
    setTimeout(() => {}, 1);
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      }
    }, 1000);
  }

  otpOnSubmit() {
    let data = {
      otp: this.otp,
      email: this.selectedUserEmail,
      contact_number: this.signatoryDetails?.contact_number,
    };
    this.eSignService.verifySendOtp(data).subscribe((res) => {
      this.modalService.dismissAll();
      this.messageService.add({
        severity: 'success',
        summary: 'OTP authenticated successfully',
        detail: '',
      });
      this.displayConsentModal = true;
      this.consentShown = true;
    });
  }

  sendOtpValidate() {
    this.eSignService
      .sendOtpToVerify(
        this.selectedUserEmail,
        this.orderId,
        this.signatoryId,
        this.signatoryDetails?.contact_number,
      )
      .subscribe((res) => {
        let detailMsg = '';
        if (this.signatoryDetails?.is_sms) {
          detailMsg = 'An OTP has been sent to ' + this.signatoryDetails?.email;
          if (this.signatoryDetails?.contact_number) {
            detailMsg += ' and ' + this.signatoryDetails?.contact_number;
          }
        } else {
          detailMsg = 'An OTP has been sent to ' + this.signatoryDetails?.email;
        }
        this.messageService.add({
          severity: 'success',
          summary: 'OTP Validation',
          detail: detailMsg,
        });
        this.startTimer();
      });
  }

  resendOtp() {
    this.sendOtpLink = true;
    this.timeLeft = 60;
    this.startTimer();
    this.sendOtpValidate();
    this.showOtpComponent = false;
    this.otp = null;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }

  // Clicking a position box: first sign needs a fresh sign_url from the
  // backend (getParallelSignData), but re-editing an already-chosen
  // signature just reopens the same modal — re-hitting the API on every
  // click (as the box previously did unconditionally) breaks re-signing,
  // since the external sign session isn't meant to be re-fetched.
  onSignatureBoxClick() {
    if (this.signImage) {
      const modalElement = document.getElementById('signModel');
      if (modalElement) {
        new bootstrap.Modal(modalElement, {
          backdrop: 'static',
          keyboard: false,
        }).show();
      }
    } else {
      this.getParallelSignData();
    }
  }

  getParallelSignData() {
    this.eSignService
      .getExternalSignLink(this.signatoryId, this.orderId)
      .subscribe({
        next: (res: any) => {
          if (res['content'] && Object.keys(res['content']).length === 0) {
            this.messageService.add({
              severity: 'warn',
              detail: res['message'],
            });
            this.eSignService.checkForImageCaptureRefresh(res['message']);
            return;
          }
          if (!res['content'] || !res['content']['sign_url']) {
            this.messageService.add({
              severity: 'warn',
              detail:
                res['message'] ||
                'Another signatory is currently signing. Please try after 10 minutes.',
            });
            this.eSignService.checkForImageCaptureRefresh(res['message']);
            return;
          }
          if (res['content'] && res['content']['redirect_url']) {
            this.redirecturl = res['content']['redirect_url'];
          }
          const modalElement = document.getElementById('signModel');
          if (modalElement) {
            const modalInstance = new bootstrap.Modal(modalElement, {
              backdrop: 'static',
              keyboard: false,
            });
            modalInstance.show();
          } else {
            console.error('Modal element not found!');
          }
        },
        error: (err) => {
          const errMsg = err?.error?.message || '';
          this.eSignService.checkForImageCaptureRefresh(errMsg);
        },
      });
  }


  shareToEmail() {
    if (this.isEmailButtonDisabled) {
      this.messageService.add({
        severity: 'warn',
        detail: `Please wait ${this.emailCooldownTime} seconds before sending again.`,
        life: 3000,
      });
      return;
    }
    const payload = {
      esign_id: this.queryParams.esign_id,
      signatory_id: this.queryParams.signatory_id,
      notify_type: 'ESIGN_SUCCESS',
    };
    this.isEmailButtonDisabled = true;
    this.eSignService.sendEmailNotification(payload).subscribe({
      next: (response) => {
        this.messageService.add({
          severity: 'success',
          detail: 'Signed document has been sent to your email successfully.',
          life: 3500,
        });
        this.startEmailCooldown();
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          detail: 'Failed to send email. Please try again.',
          life: 3500,
        });
        this.isEmailButtonDisabled = false;
      },
    });
  }

  startEmailCooldown() {
    this.emailCooldownTime = 10;
    this.emailCooldownInterval = setInterval(() => {
      this.emailCooldownTime--;
      if (this.emailCooldownTime <= 0) {
        this.isEmailButtonDisabled = false;
        clearInterval(this.emailCooldownInterval);
      }
    }, 1000);
  }

  printDocument() {
    const documentBase64 = this.signerData?.document;
    if (documentBase64) {
      try {
        const byteArray = this.base64ToUint8Array(documentBase64);
        const file = new Blob([byteArray], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        iframe.style.visibility = 'hidden';
        document.body.appendChild(iframe);
        iframe.src = fileURL;
        iframe.onload = () => {
          setTimeout(() => {
            try {
              iframe.contentWindow?.focus();
              iframe.contentWindow?.print();
              const cleanupHandler = () => {
                setTimeout(() => {
                  if (document.body.contains(iframe))
                    document.body.removeChild(iframe);
                  URL.revokeObjectURL(fileURL);
                }, 100);
              };
              iframe.contentWindow?.addEventListener(
                'afterprint',
                cleanupHandler,
              );
              setTimeout(cleanupHandler, 60000);
            } catch (e) {
              console.error('Print error:', e);
              if (document.body.contains(iframe))
                document.body.removeChild(iframe);
              URL.revokeObjectURL(fileURL);
            }
          }, 500);
        };
      } catch (error) {}
    }
  }

  downloadDocument() {
    const documentBase64 = this.signerData?.document;
    const esignId = this.signatoryDetails?.esign_id;
    if (documentBase64) {
      try {
        const byteArray = this.base64ToUint8Array(documentBase64);
        const file = new Blob([byteArray], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        const sanitizedId = esignId
          ? esignId.replace(/ /g, '_')
          : `signed_document_${Date.now()}`;
        link.download = `${sanitizedId}.pdf`;
        link.click();
        URL.revokeObjectURL(fileURL);
      } catch (error) {
        console.error('Error downloading document:', error);
      }
    }
  }
}